<template>
    <b-modal
        v-model="modal"
        :title="isEdit ? 'Edit' : 'Add'"
        hide-footer
        centered
        @show="setData"
        @hidden="resetData"
    >
        <b-form @submit.prevent="onSubmit">
            <b-form-group label="Username">
                <b-form-input
                    v-model="form.username"
                    required
                    maxlength="64"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="AwsPayerAccountId">
                <b-form-select
                    v-model="form.awsPayerAccountId"
                    :options="items"
                    required
                ></b-form-select>
            </b-form-group>
            <b-form-group label="AWS Account ID">
                <b-form-input
                    v-model="form.awsAccountId"
                    minlength="12"
                    maxlength="12"
                    :disabled="isEdit"
                    required
                ></b-form-input>
            </b-form-group>
            <b-form-group>
                <b-form-checkbox v-model="form.isActive" switch required
                    >isActive</b-form-checkbox
                >
            </b-form-group>
            <b-button type="submit" block variant="primary">Save</b-button>
        </b-form>
    </b-modal>
</template>

<script>
import { getPayerAwsAccounts } from '@/services/aws.service';
import { addAwsAccount, editAwsAccount } from '@/services/aws.service';

const INIT_FORM_DATA = {
    username: null,
    awsPayerAccountId: '',
    awsAccountId: '',
    isActive: true,
};
export default {
    name: 'AddOrEditModal',
    props: {
        value: {
            type: Boolean,
            required: true,
            default: false,
        },
        currentData: {
            type: [Object, null],
            required: false,
            default() {
                return null;
            },
        },
    },
    computed: {
        modal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        isEdit() {
            return !!this.currentData;
        },
    },
    data() {
        return {
            form: {
                ...INIT_FORM_DATA,
            },
            items: [],
            perPage: 100,
            currentPage: 1,
            total: 0,
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            const query = {
                page: this.currentPage,
                limit: this.perPage,
            };
            getPayerAwsAccounts(query).then(({ data }) => {
                const { accounts, paginate } = data;
                this.items = accounts.map((item) => {
                    return {
                        text: item.awsAccountName,
                        value: item.id,
                    };
                });
                this.perPage = paginate.perPage;
                this.currentPage = paginate.currentPage;
                this.total = paginate.total;
                if (this.isEdit) {
                    this.form.awsPayerAccountId = this.items.find(
                        (item) =>
                            item.text === this.currentData.awsPayerAccountName
                    ).value;
                }
            });
        },
        setData() {
            if (this.isEdit) {
                this.form.username = this.currentData.username;
                if (this.items.length > 0) {
                    this.form.awsPayerAccountId = this.items.find(
                        (item) =>
                            item.text === this.currentData.awsPayerAccountName
                    ).value;
                }
                this.form.awsAccountId = this.currentData.awsAccountId;
                this.form.isActive = this.currentData.isActive;
            }
        },
        resetData() {
            this.form = { ...INIT_FORM_DATA };
        },
        onSubmit() {
            const saveFunc = this.isEdit ? this.editData : this.addData;
            saveFunc()
                .then(() => {
                    this.$bvToast.toast(`Save success!`, {
                        title: 'Success',
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant: 'success',
                        solid: false,
                        toaster: 'b-toaster-top-center',
                    });
                    this.$emit('onDone');
                    this.modal = false;
                })
                .catch((e) => {
                    const data = e.response?.data || {};

                    this.form.isCreateNewUser = !data.isCreatedUser;
                    const message = data.message || 'An error occurred!';
                    this.$bvToast.toast(message, {
                        title: 'Error',
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant: 'danger',
                        solid: false,
                        toaster: 'b-toaster-top-center',
                    });
                });
        },
        async addData() {
            return addAwsAccount(this.form);
        },
        async editData() {
            return editAwsAccount(this.currentData.id, this.form);
        },
    },
};
</script>

<style scoped></style>
